import { adviserMetaAdviceRoomsApi } from './adviceRooms';

export function adviserMetaApi(path: string) {
  return {
    path,
    adviceRooms: () => adviserMetaAdviceRoomsApi(`${path}/client-meeting-rooms`),
  };
}
